import CTLBooleanCell from "application/components/CTLBooleanCell";
import StaticDropDownCell from "application/components/CTLStaticDropDownCell";
import CTLUnReadCell from "application/components/CTLUnReadCell";
import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";
import { callCenterConfigMenuMoreVert } from "globals/configuration/callCenterConfigMenuMoreVert";
import formControl from "globals/form-control";

const getUpdateColumns = (onDelete, onEdit) => {
  return [
    {
      Header: "Name",
      accessor: "name",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      disabled: true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Agent Full Name",
      accessor: "agentFullName",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      width: 6,
      disabled: false,
      displayInDeleteConfirmation: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Contact",
      accessor: "contact",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Default Queue",
      accessor: "defaultQueue",
      displayInList: true,
      allowInForm: true,
      controlType: "select",
      width: 6,
      options: {
        keyField: "id",
        keyDescription: "description",
        values: [
          { id: "51", description: "Acd Queue 51" },
          { id: "52", description: "Acd Queue 52" },
          { id: "53", description: "Acd Queue 53" },
          { id: "54", description: "Acd Queue 54" },
          { id: "55", description: "Acd Queue 55" },
          { id: "56", description: "Acd Queue 56" },
          { id: "57", description: "Acd Queue 57" },
          { id: "58", description: "Acd Queue 58" },
          { id: "59", description: "Acd Queue 59" },
          { id: "60", description: "Acd Queue 60" },
          { id: "61", description: "Acd Queue 61" },
          { id: "62", description: "Acd Queue 62" },
          { id: "63", description: "Acd Queue 63" },
          { id: "64", description: "Acd Queue 64" },
        ],
      },
      Cell: ({ row, value }) => <StaticDropDownCell row={row} value={value} />,
    },
    {
      Header: "Type",
      accessor: "type",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },

    {
      Header: "MaxNoAnswer(In Sec)",
      accessor: "maxNoAnswer",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      width: 6,
      validation: formControl.string().digitsOnly(),
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "WrapUpTime (In Sec)",
      accessor: "wrapUpTime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      validation: formControl.string().digitsOnly(),
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "RejectDelayTime (In Sec)",
      accessor: "rejectDelayTime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      validation: formControl.string().digitsOnly(),
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "BusyDelayTime (In Sec)",
      accessor: "busyDelayTime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      validation: formControl.string().digitsOnly(),
      dataType: "integer",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "NoAnswerDelayTime (In Sec)",
      accessor: "noAnswerDelayTime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      validation: formControl.string().digitsOnly(),
      dataType: "integer",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "IsOnDemand",
      accessor: "isOnDemand",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      width: 6,
      Cell: ({ value }) => <CTLBooleanCell value={value} />,
    },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      allowInForm: false,
      Cell: ({ row, value }) => (
        <RowAction
          row={row}
          value={value}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ),
    },
  ];
};

export { getUpdateColumns };
